import {useMutation} from '@github-ui/react-query'
import {apiUpdateIssueLabelsBulk, type UpdateIssueLabelsBulkRequest} from '../api/api-update-issue-labels-bulk'
import {parseGraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {Label} from '../api/label'

type UseUpdateIssueLabelsBulkMutationInput = UpdateIssueLabelsBulkRequest & {labels?: Label[]}

type UseUpdateIssueLabelsBulkMutationOptions = {
  onMutate: (variables: UseUpdateIssueLabelsBulkMutationInput) => void
}

export function useUpdateIssueLabelsBulkMutation({onMutate}: UseUpdateIssueLabelsBulkMutationOptions) {
  return useMutation({
    mutationFn: async ({labels, ...request}: UseUpdateIssueLabelsBulkMutationInput) => {
      const responseJson = await apiUpdateIssueLabelsBulk(request)
      const responseData = parseGraphQLResponse(responseJson)
      return responseData
    },
    onMutate,
  })
}
